<template>
    <div v-if="hasFieldToDisplay()" style="margin-bottom: 50px">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Contacts
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="mt-5">
                <div class="d-flex justify-start flex-wrap" style="margin-left: -20px; margin-right: -20px">
                    <div v-for="(contact, index) in provider.contacts"
                         class="mb-5 mt-5"
                         style="margin-left: 20px; margin-right: 20px">
                        <v-card width="400px">
                            <v-app-bar dark :color="primaryColor">
                                <div class="d-flex justify-content-between w-100">
                                    <div class="mt-auto mb-auto cmaj-title">
                                        <span>{{ contact.first_name }} {{ contact.last_name }}</span>
                                    </div>

                                    <div class="d-flex">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon @click="prepareEdit(contact, index)">
                                                    <v-icon dense>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <div>Modifier</div>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon @click="removeContact(index)">
                                                    <v-icon dense>close</v-icon>
                                                </v-btn>
                                            </template>
                                            <div>Supprimer</div>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </v-app-bar>

                            <v-card-text>
                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_FIRST_NAME')">
                                    <div><b>{{ getField('CONTACT_FIRST_NAME').name }}</b></div>

                                    <div v-if="contact.first_name !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.first_name }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_LAST_NAME')">
                                    <div><b>{{ getField('CONTACT_LAST_NAME').name }}</b></div>

                                    <div v-if="contact.last_name !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.last_name }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_EMAIL')">
                                    <div><b>{{ getField('CONTACT_EMAIL').name }}</b></div>

                                    <div v-if="contact.email !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.email }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_PHONE')">
                                    <div><b>{{ getField('CONTACT_PHONE').name }}</b></div>

                                    <div v-if="contact.phone !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.phone }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_PROFESSION')">
                                    <div><b>{{ getField('CONTACT_PROFESSION').name }}</b></div>

                                    <div v-if="contact.profession !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.profession.label }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('CONTACT_TITLE')">
                                    <div><b>{{ getField('CONTACT_TITLE').name }}</b></div>

                                    <div v-if="contact.title !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.title }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>

                                <div class="mt-1 justify-content-between d-flex" v-if="hasField('ContactFonction')">
                                    <div><b>{{ getField('ContactFonction').name }}</b></div>

                                    <div v-if="contact.profession !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                        {{ contact.profession.label }}
                                    </div>
                                    <div v-else>Non renseigné</div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>

                    <div class="text-center w-100 mt-5">
                        <v-btn color="primary" @click="addNewContact">
                            <v-icon small class="mr-2">add</v-icon>
                            Ajouter un contact
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog persistent content-class="pro-dialog" v-model="contactDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <h2 class="headline-title" v-if="!edit">Ajout d'un contact</h2>
                    <h2 class="headline-title" v-else>Modification d'un contact</h2>

                    <v-btn icon class="close-modal-icon" @click="contactDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-spacer></v-spacer>
                    <div class="mt-3 text-center">
                        <apidae-contact-item
                            :contact="currentContact"
                            :required-field="false"
                            :professions="professions"
                            :index="currentIndex"
                            :edit="edit">
                        </apidae-contact-item>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
import ApidaeContactItem from "./ApidaeContactItem"
import Confirm from "../../tools/Confirm"

export default {
    name: "ApidaeContacts",
    components: {Confirm, ApidaeContactItem},
    props: ['index', 'professions'],
    data() {
        return {
            currentContact: {},
            currentIndex: null,
            edit: false,
            contactDialog: false
        }
    },
    methods: {
        ...mapMutations('web_form', ['deleteContact']),
        hasFieldToDisplay() {
            return this.hasField('CONTACT_LAST_NAME') ||
                this.hasField('CONTACT_FIRST_NAME') ||
                this.hasField('CONTACT_PHONE') ||
                this.hasField('CONTACT_EMAIL') ||
                this.hasField('CONTACT_PROFESSION')
        },
        prepareEdit(contact, index) {
            this.$global.$emit('reset-submitted')

            this.edit = true
            this.currentContact = JSON.parse(JSON.stringify(contact))
            this.currentIndex = index
            this.contactDialog = true
        },
        removeContact(index) {
            let message = 'Vous allez supprimer le contact'

            if(this.provider.contacts[index].first_name !== null) {
                message += ' <b>' + this.provider.contacts[index].last_name + ' ' +
                    this.provider.contacts[index].first_name + '</b>'
            }

            message += '. Êtes-vous sûr de vouloir supprimer ce contact ?'

            this.$refs.confirm.open('Attention', message,
                { color: 'red', confirmColor: 'red', cancelColor: '#0b697e' }).
            then((confirm) => {
                if (confirm) {
                    this.deleteContact(index)
                }
            })
        },
        addNewContact() {
            let contact = {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                profession: null,
            }

            this.$global.$emit('reset-submitted')

            this.edit = false
            this.currentContact = contact
            this.contactDialog = true
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled', 'fields']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField'])
    },
    created() {
        this.$global.$on('close-dialog', () => {
            this.contactDialog = false
        })
    },
    beforeDestroy() {
        this.$global.$off('close-dialog')
    }
}
</script>
